<template>
  <div class="editor-image__parent-flex">
    <div
      class="editor-main-image__wrapper editor-wrapper"
      :class="{ editable: editable }"
    >
      <div class="editor-main-image__content">
        <h1
          class="editor-main-image__title"
          :contenteditable="editable"
          placeholder="Главный заголовок"
          @blur="handleTitleChange"
          v-text="title"
        ></h1>
        <p
          class="editor-main-image__announce"
          :contenteditable="editable"
          placeholder="Анонс"
          @blur="handleAnnounceChange"
          v-text="announce"
        ></p>
        <p v-if="time || editable" class="editor-main-image__time">
          На чтение:
          <span v-if="time"
            >{{ time }} {{ contentTime(time, getContentText('time')) }}</span
          ><span v-else>(добавляется справа)</span>
        </p>
        <EditorContentImage
          :editable="editable"
          :image-src="imageSrc"
          :description="description"
          :source="source"
          @update:image-src="handleImageSrcChange"
          @update:description="handleDescriptionChange"
          @update:source="handleSourceChange"
          @delete="handleImageDelete"
        >
          <template v-if="!imageSrc" #default="{ showUploader }">
            <div class="editor-main-image__uploader" @click="showUploader">
              <div class="editor-main-image__preview-content">
                <div class="editor-main-image__preview-icon">
                  <SvgIcon name="editor/preview" />
                </div>
                <div class="editor-main-image__preview-text">
                  <div>Обложка для статьи</div>
                  <div>Перетащите файл или нажмите</div>
                </div>
              </div>
              <div class="editor-main-image__uploader-desc">
                мин. размер 800х300
              </div>
            </div>
          </template>
        </EditorContentImage>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  editable: { type: Boolean, default: false },
  imageSrc: { type: String, default: null },
  title: { type: [String, Number], default: '' },
  announce: { type: [String, Number], default: '' },
  description: { type: [String, Number], default: '' },
  source: { type: [String, Number], default: '' },
  time: { type: Number, default: null },
});

const { contentTime, getContentText } = useTimeForModel();

const emit = defineEmits([
  'update:title',
  'update:announce',
  'update:image-src',
  'update:description',
  'update:source',
]);

// const imageSrcHosted = computed(() => {
//   // Для просмотра локально
//   if (process.env.NODE_ENV === 'development') {
//     return `${this.$config.clientHost}${this.imageSrc}`;
//   }

//   return this.imageSrc;
// });

const handleTitleChange = (e) => {
  emit('update:title', e.target.textContent);
};

const handleAnnounceChange = (e) => {
  emit('update:announce', e.target.textContent);
};

const handleImageSrcChange = (src) => {
  emit('update:image-src', src);
};

const handleDescriptionChange = (description) => {
  emit('update:description', description);
};

const handleSourceChange = (source) => {
  emit('update:source', source);
};

const handleImageDelete = () => {
  emit('update:image-src', null);
};
</script>
